// scenario type
export const TEXT_URL_BUTTON = 'TEXT_URL_BUTTON';
export const TEXT_NAVIGATE_BUTTON = 'TEXT_NAVIGATE_BUTTON';
export const TEXT_API_BUTTON = 'TEXT_API_BUTTON';

// scenario name
export const FREQUENTLY_ASKED_MESSAGE = 'FREQUENTLY_ASKED_MESSAGE';
